/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-floating-promises */

import { useEffect } from 'react';
import { useSelector, connect } from 'react-redux';
import { getScopesAsMap } from '../../selectors/userSelectors/getScopesAsMap';
import { getCurrentOwnerId } from '../../crm-integration/selectors/getCurrentOwnerId';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'cust... Remove this comment to see the full error message
import ErrorBoundary from 'customer-data-objects-ui-components/ErrorBoundary';
import Loadable from 'UIComponents/decorators/Loadable';
import CallingWidgetError from 'call-widget-addon/widget-error/components/CallingWidgetError';
import { getFocusedViewMemberThreadId } from '../../focused-view-member/selectors/getFocusedViewMemberThreadId';
import updateCallingThreadId from 'calling-global-api/methods/updateCallingThreadId';
import { getCallingGates } from '../../selectors/gateSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
const AsyncCallingWidget = Loadable({
  loader: () => import( /* webpackChunkName: "calling-widget" */'call-widget-addon/CallingWidget'),
  LoadingComponent: () => null,
  // eslint-disable-next-line react/display-name
  ErrorComponent(error) {
    return /*#__PURE__*/_jsx(CallingWidgetError, {
      error: error,
      appName: "Inbox",
      isWidgetHidden: false,
      onSetIsWidgetHidden: () => {}
    });
  }
});
const inboxCapabilities = {
  customAssociations: false,
  callOutcomes: true,
  callTypes: false,
  callingProviders: false,
  fontStyles: true,
  followupTasks: false
};
export const InboxCallingWidgetContainer = ({
  focusedThreadId,
  gates
}) => {
  const scopes = useSelector(getScopesAsMap);
  const ownerId = useSelector(getCurrentOwnerId);
  useEffect(() => {
    if (scopes && ownerId && focusedThreadId) {
      updateCallingThreadId({
        threadId: focusedThreadId
      });
    }
  }, [focusedThreadId, scopes, ownerId]);
  if (scopes && ownerId) {
    return /*#__PURE__*/_jsx(ErrorBoundary, {
      boundaryName: "callCommunicatorWrapper",
      children: /*#__PURE__*/_jsx(AsyncCallingWidget, {
        ownerId: ownerId,
        defaultHidden: true,
        appIdentifier: "inbox",
        scopes: scopes,
        isQueueTask: false,
        capabilities: inboxCapabilities,
        gates: gates
      })
    }, "CallCommunicatorWrapper");
  }
  return null;
};
InboxCallingWidgetContainer.displayName = 'InboxCallingWidgetContainer';
const mapStateToProps = state => {
  return {
    gates: getCallingGates(state),
    focusedThreadId: getFocusedViewMemberThreadId(state)
  };
};
export default connect(mapStateToProps)(InboxCallingWidgetContainer);